export type Lang = 'en' | 'es' | 'fr' | 'de' | 'pt';

const STRINGS: Record<Lang, Record<string, string>> = {
  en: {
    play: 'New Game',
    continue: 'Continue',
    settings: 'Settings',
    credits: 'Credits',
    achievements: 'Achievements',
    encyclopedia: 'Encyclopedia',
    daily: 'Daily Challenge',
    pause: 'Paused',
    resume: 'Resume',
    restart: 'Restart',
    quit: 'Main Menu',
    gameOver: 'Base Destroyed',
    victory: 'Victory!',
    endless: 'Enter Endless',
    wave: 'Wave',
    gold: 'Gold',
    lives: 'Lives',
    score: 'Score',
    sell: 'Sell',
    upgrade: 'Upgrade',
    targeting: 'Targeting',
    build: 'Build',
    speed: 'Speed',
  },
  es: {
    play: 'Nueva Partida',
    continue: 'Continuar',
    settings: 'Ajustes',
    credits: 'Créditos',
    achievements: 'Logros',
    encyclopedia: 'Enciclopedia',
    daily: 'Desafío Diario',
    pause: 'Pausa',
    resume: 'Reanudar',
    restart: 'Reiniciar',
    quit: 'Menú Principal',
    gameOver: 'Base Destruida',
    victory: '¡Victoria!',
    endless: 'Modo Infinito',
    wave: 'Oleada',
    gold: 'Oro',
    lives: 'Vidas',
    score: 'Puntos',
    sell: 'Vender',
    upgrade: 'Mejorar',
    targeting: 'Objetivo',
    build: 'Construir',
    speed: 'Velocidad',
  },
  fr: {
    play: 'Nouvelle Partie',
    continue: 'Continuer',
    settings: 'Paramètres',
    credits: 'Crédits',
    achievements: 'Succès',
    encyclopedia: 'Encyclopédie',
    daily: 'Défi Quotidien',
    pause: 'Pause',
    resume: 'Reprendre',
    restart: 'Recommencer',
    quit: 'Menu Principal',
    gameOver: 'Base Détruite',
    victory: 'Victoire !',
    endless: 'Mode Sans Fin',
    wave: 'Vague',
    gold: 'Or',
    lives: 'Vies',
    score: 'Score',
    sell: 'Vendre',
    upgrade: 'Améliorer',
    targeting: 'Ciblage',
    build: 'Construire',
    speed: 'Vitesse',
  },
  de: {
    play: 'Neues Spiel',
    continue: 'Fortsetzen',
    settings: 'Einstellungen',
    credits: 'Mitwirkende',
    achievements: 'Erfolge',
    encyclopedia: 'Enzyklopädie',
    daily: 'Tägliche Herausforderung',
    pause: 'Pause',
    resume: 'Weiter',
    restart: 'Neustart',
    quit: 'Hauptmenü',
    gameOver: 'Basis Zerstört',
    victory: 'Sieg!',
    endless: 'Endlosmodus',
    wave: 'Welle',
    gold: 'Gold',
    lives: 'Leben',
    score: 'Punkte',
    sell: 'Verkaufen',
    upgrade: 'Aufrüsten',
    targeting: 'Zielmodus',
    build: 'Bauen',
    speed: 'Tempo',
  },
  pt: {
    play: 'Novo Jogo',
    continue: 'Continuar',
    settings: 'Configurações',
    credits: 'Créditos',
    achievements: 'Conquistas',
    encyclopedia: 'Enciclopédia',
    daily: 'Desafio Diário',
    pause: 'Pausado',
    resume: 'Continuar',
    restart: 'Reiniciar',
    quit: 'Menu Principal',
    gameOver: 'Base Destruída',
    victory: 'Vitória!',
    endless: 'Modo Infinito',
    wave: 'Onda',
    gold: 'Ouro',
    lives: 'Vidas',
    score: 'Pontuação',
    sell: 'Vender',
    upgrade: 'Melhorar',
    targeting: 'Alvo',
    build: 'Construir',
    speed: 'Velocidade',
  },
};

export function t(lang: Lang, key: string): string {
  return STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;
}
